"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _productImage = require("../productContent/productImage");
var _productName = require("../productContent/productName");
var _productAvailability = require("../productContent/productAvailability");
var _cartItemDropdownList = require("../cartItemDropdownList/cartItemDropdownList");
var _enums = require("../../constants/enums");
var _wbmInputs = require("wbm-inputs");
var _wbmFormatMoney = require("wbm-format-money");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CartItem = exports.CartItem = function CartItem(props) {
  var customizeUrl;
  if (props.customizedUrl) {
    customizeUrl = props.customizedUrl;
  }
  var sellPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: props.sellPrice || 0,
    useCurrencySign: true
  });
  var unitPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: props.unitPrice || 0,
    useCurrencySign: true
  });
  var listPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: props.listPrice || 0,
    useCurrencySign: true
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cart-item-wrapper ".concat(props.isMobile ? 'mobile-view' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cart-item-object"
  }, props.imageNotLoaded ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '90px',
      height: '90px'
    },
    className: "skeleton"
  }) : /*#__PURE__*/_react["default"].createElement(_productImage.ProductImage, {
    imgUrl: props.imgUrl,
    altText: props.altText,
    width: 72,
    height: 72
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cart-item-right"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "productname-price"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-name"
  }, /*#__PURE__*/_react["default"].createElement(_productName.ProductName, {
    brandName: props.brandName,
    description: props.description,
    qty: props.qty,
    textBold: true,
    displayId: props.itemId ? props.itemId : '',
    itemIdentifier: props.itemIdentifier,
    itemIndicators: props.itemIndicators
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pricing"
  }, props.sellPrice && props.supercedePopup ? props.displayLowerOriginalPrice !== _enums.SupercedeDisplayCondition.Never && /*#__PURE__*/_react["default"].createElement("div", {
    className: "sale-price"
  }, sellPrice, " /", props.unitId) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-price"
  }, props.unitPrice ? unitPrice : ''), /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id"
  }, "/", props.unitId)), props.displayListPrice ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "list-price"
  }, props.listPrice ? listPrice : ""), /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id"
  }, "/", props.unitId)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)), props.purchaseProcess === _enums.PurchaseProcess.NavInk ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "customize-button"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: customizeUrl
  }, "Customize")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " "), props.removeMultiSelect && /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "wbm-button btn btn-link medium",
    onClick: function onClick() {
      return props.removeMultiSelect ? props.removeMultiSelect() : '';
    }
  }, "Remove"))), props.availabilityInfo ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-availability"
  }, " ", /*#__PURE__*/_react["default"].createElement(_productAvailability.ProductAvailability, {
    itemIdentifier: props.itemIdentifier,
    availabilityInfo: props.availabilityInfo,
    smallText: props.smallText
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), props.availabilityInfo && props.availabilityInfo.doPreventAddToCart == true ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-not-availabile"
  }, /*#__PURE__*/_react["default"].createElement("div", null, "It cannot be added to your cart.")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), props.purchaseProcess === _enums.PurchaseProcess.NavInk ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "customize-warning"
  }, "This item must be customized before adding to cart.") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " "))), props.isCartItemDropdown && /*#__PURE__*/_react["default"].createElement(_cartItemDropdownList.CartItemDropdownList, props.cartItemDropdownProps));
};
//# sourceMappingURL=cartItem.js.map